import React from 'react';
import { ModalDialog } from './ModalDialog';

export function ItemRanOutOfStockDialog({
    visible,
    hasHotels,
    onClick,
}) {
    const title = !hasHotels
        ? 'The tickets have run out'
        : 'The hotel has been fully booked';
    const text = !hasHotels
        ? 'Unfortunately, your selected tickets have just sold out. Please start over with your booking.'
        : 'Unfortunately, your selected hotel has just sold out on the desired date. Please start over with your booking.';

    return (
        <ModalDialog
            visible={visible}
            primaryAction={onClick}
            primaryActionText="Start a new booking"
            secondaryAction={onClick}
            icon="exclamation"
            header={title}
            body={text}
        />
    );
}
